import { INDEPENDENCE_DISCLAIMER, LEGAL_PAGE_META, type LegalPageKey } from '@titrate/shared';
import { DRAFT_NOTICE } from '../content/legal';
import { Callout, Markdown } from '../components/ui';
import { usePageMeta } from '../lib/pageMeta';

function LegalPage({ page, draft = true }: { page: LegalPageKey; draft?: boolean }) {
  const meta = LEGAL_PAGE_META[page];
  // Matches the title/description the server already prerenders for this
  // exact path (see apps/api/src/routes/legal.ts) — same source, so a
  // client-side navigation here never disagrees with what a crawler read.
  usePageMeta({ title: meta.title.replace(/ — Titrate$/, ''), description: meta.description, path: meta.path });

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      {draft && <Callout tone="warn">{DRAFT_NOTICE}</Callout>}
      <article className="card p-5 sm:p-8">
        <Markdown content={meta.content} />
      </article>
      <Callout>{INDEPENDENCE_DISCLAIMER}</Callout>
    </div>
  );
}

export const Terms = () => <LegalPage page="terms" draft={false} />;
export const Privacy = () => <LegalPage page="privacy" draft={false} />;
export const Refunds = () => <LegalPage page="refunds" />;
export const MarketplaceTerms = () => <LegalPage page="marketplace-terms" />;
